// 电子贺卡
const config = {
  'electronic.card.text.change': {
    operation: ['touch', 'visible'],
    c: {
      type: 'constant',
      value: 'change',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'electronic.card.wish.item': {
    operation: ['touch', 'visible'],
    c: {
      type: 'variable',
      func: ({ type, index }) => {
        let spmb = '';
        if (type === 1) {
          spmb = 'text';
        } else if (type === 2) {
          spmb = 'audio';
        } else if (type === 3) {
          spmb = 'video';
        }
        return spmb;
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'electronic.card.theme.item': {
    operation: ['touch', 'visible'],
    c: {
      type: 'constant',
      value: 'style',
    },
    d: {
      type: 'variable',
      func: ({ index }) => {
        return index + 1;
      },
    },
    iid: {
      type: 'variable',
      func: ({ template_id }) => {
        return `template_id=${template_id}`;
      },
    },
  },
  'electronic.card.create': {
    operation: ['touch', 'visible'],
    c: {
      type: 'constant',
      value: 'generate',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: ({ type, ifreceive }) => {
        return `type=${type}&if_received=${ifreceive}`;
      },
    },
  },
  'electronic.card.videowish': {
    operation: ['touch', 'visible'],
    c: {
      type: 'constant',
      value: 'video_type',
    },
    d: {
      type: 'variable',
      func: ({ type }) => {
        return `${type}`;
      },
    },
  },
  'electronic.card.audiowish': {
    operation: ['touch', 'visible'],
    c: {
      type: 'constant',
      value: 'audio_type',
    },
    d: {
      type: 'variable',
      func: ({ type }) => {
        return `${type}`;
      },
    },
  },
  'electronic.card.guide': {
    operation: ['touch', 'visible'],
    c: {
      type: 'constant',
      value: 'guide',
    },
    d: {
      type: 'constant',
      value: '1'
    },
  },
  'electronic.card.preview.hide': {
    operation: ['touch', 'visible'],
    c: {
      type: 'constant',
      value: 'hide',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: ({ checked }) => {
        return `status=${checked ? 1 : 2}`;
      },
    },
  },
  'electronic.card.preview.re_view': {
    operation: ['touch', 'visible'],
    c: {
      type: 'constant',
      value: 're_view',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'electronic.card.preview.re_edit': {
    operation: ['touch', 'visible'],
    c: {
      type: 'constant',
      value: 're_edit',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'electronic.card.preview.share_1': {
    operation: ['touch', 'visible'],
    c: {
      type: 'constant',
      value: 'share',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: ({ ifreceive, type }) => {
        return `if_received=${ifreceive}&type=${type}&step=1`;
      },
    },
  },
  'electronic.card.preview.share_2': {
    operation: ['touch', 'visible'],
    c: {
      type: 'constant',
      value: 'share',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: ({ ifreceive, type }) => {
        return `if_received=${ifreceive}&type=${type}&step=2`;
      },
    },
  },
};

export default config;
